module.exports = __webpack_public_path__ + "img/right_circle1.89500705.png";